import { initializeApp } from "firebase/app";
import { z } from "zod";

export * from "./constants";

export const ConfigSchema = z.object({
  app: z.object({
    env: z.enum(["development", "production"]),
    isProd: z.boolean(),
    enableAnalytics: z.boolean(),
    platform: z.union([z.literal("web"), z.literal("ios"), z.literal("android"), z.string()]),
    isNative: z.boolean(),
    clientBaseUrl: z.string().url(),
    apiBaseUrl: z.string().url()
  }),

  firebase: z.object({
    apiKey: z.string(),
    authDomain: z.string(),
    projectId: z.string(),
    storageBucket: z.string(),
    messagingSenderId: z.string(),
    appId: z.string(),
    measurementId: z.string()
  })
});

export type Config = z.infer<typeof ConfigSchema>;

let config: Config | null = null;

/**
 * Need to be called as soon as possible to initialize libs
 **/
export function init(cfg: unknown): Config {
  if (config) throw new Error("Config already initialized");

  const parsed = ConfigSchema.parse(cfg);
  config = Object.freeze(parsed);

  initializeApp(config.firebase);

  return config;
}

export function getConfig() {
  if (!config) throw new Error("Config not initialized");
  return config;
}
